import Vue from 'vue';

import ReprintCalculator from './components/ReprintCalculator.vue';
import Modal from './components/Modal.vue';

Vue.config.productionTip = false;

Vue.component('reprint-calculator', ReprintCalculator);
Vue.component('modal', Modal);

const app = new Vue({
  el: '#app',
});
